import { css, type Theme } from '@emotion/react';
import type { OnLog } from 'client/state/LogState';
import { Stack } from 'client/components/Stack';
import type { ComponentStatusTree } from './componentsStatusUtils';
import { ComponentSubContainer } from './ComponentSubContainer';

interface ComponentSubContainersProps {
  deploymentID: number | null | undefined;
  deploymentUrl: string;
  namespace: string;
  pod: string;
  containers: ComponentStatusTree['containers'][number]['containers'];
  initContainers: ComponentStatusTree['containers'][number]['initContainers'];
  onLog?: OnLog;
}

export const ComponentSubContainers = ({
  deploymentID,
  deploymentUrl,
  namespace,
  pod,
  containers,
  initContainers,
  onLog,
}: ComponentSubContainersProps) => {
  const items = [...containers, ...initContainers];

  return (
    <Stack component="ul" gap={6} css={listStyle}>
      {items.map((item, index) => (
        <ComponentSubContainer
          key={`${item.name}-${index}`}
          deploymentID={deploymentID}
          deploymentUrl={deploymentUrl}
          namespace={namespace}
          pod={pod}
          item={item}
          onLog={onLog}
        />
      ))}
    </Stack>
  );
};

const listStyle = (theme: Theme) => css`
  position: relative;
  margin: 0;
  padding: 0;
  padding-top: 6px;
  padding-left: 22px;
  list-style: none;

  &::before {
    content: '';
    position: absolute;
    display: block;
    width: 2px;
    height: 100%;
    background-color: ${theme.color.grey[60]};
    border-radius: 16px;
    top: 0;
    left: 10px;

    mask-image: linear-gradient(to bottom, transparent, white 8px);
  }
`;
